import React from "react";

export default () => {
  return (
    <div className="label-content">
      <h4>Conversion Settings</h4>
    </div>
  );
};
